// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 6969) return "static/chunks/6969-a8381e5f3e615035.js";
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 4106 ? "b9633c63" : chunkId) + "." + {"165":"32c5ba5d60f3bad6","2958":"262cf0a6155dc17c","3800":"cd8533e8d4dde1e7","4106":"430eae371c711fda","6716":"41c1cd0e87421790","8040":"8e84798ffba20179"}[chunkId] + ".js";
};